import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { TipLinkProvider } from './context/TipLinkContext'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

ReactDOM.render(
  <React.StrictMode>
    <TipLinkProvider>
      <App />
    </TipLinkProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

serviceWorkerRegistration.register()
